import React from 'react';

import Lottie from 'lottie-react-web';

import animationData from './animations/index.bk.json';

export const Animation = () => <Lottie options={{ animationData }} />;
